var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-header wrapHeader"},[_c('div',{staticClass:"wareTitle"},[_vm._v("仓房列表")]),_c('div',{staticClass:"warpTitle log"},[_vm._v(_vm._s(_vm.wareName)+" "+_vm._s(_vm.log))]),_c('backBtn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }